import { CheckIcon } from '@heroicons/react/24/outline';

type CondenserLocationLabelProps = Readonly<{
  label: string;
  isSelected: boolean;
}>;

export default function CondenserLocationLabel({
  label,
  isSelected
}: CondenserLocationLabelProps) {
  return (
    <>
      {label}
      {isSelected && <CheckIcon className='h-4 w-4 shrink-0' strokeWidth={3} />}
    </>
  );
}
